/* eslint-disable */
// Floating account switcher — shown only when a single login holds more than one
// role (e.g. a school owner who also teaches). Lets them flip between dashboards
// without separate logins. Roles are derived from the entity rows they own.
import { useState } from "react";
import { Building2, GraduationCap, User, Shield, ChevronDown } from "lucide-react";

const ROLE_META = {
  school:  { label: "School",  icon: Building2 },
  teacher: { label: "Teacher", icon: GraduationCap },
  student: { label: "Student", icon: User },
  admin:   { label: "Admin",   icon: Shield },
};

export default function AccountSwitcher({ roles = [], activeRole, onSwitchRole }) {
  const [open, setOpen] = useState(false);
  if (!roles || roles.length < 2) return null;

  const active = ROLE_META[activeRole] || ROLE_META.student;
  const ActiveIcon = active.icon;

  return (
    <div style={{ position:"fixed", bottom:20, left:"50%", transform:"translateX(-50%)", zIndex:4000, fontFamily:"'Jost',sans-serif" }}>
      {open && (
        <div style={{ position:"absolute", bottom:"calc(100% + 8px)", left:"50%", transform:"translateX(-50%)", background:"white", borderRadius:14, boxShadow:"0 12px 40px rgba(46,42,36,0.22)", border:"1px solid rgba(181,112,63,0.18)", padding:6, minWidth:200 }}>
          <div style={{ fontSize:10, letterSpacing:1.5, textTransform:"uppercase", color:"#A89B8C", fontWeight:600, padding:"8px 12px 4px" }}>Switch account</div>
          {roles.map(r => {
            const meta = ROLE_META[r] || ROLE_META.student;
            const Icon = meta.icon;
            const isActive = r === activeRole;
            return (
              <button key={r} onClick={() => { setOpen(false); if (!isActive) onSwitchRole?.(r); }}
                style={{ display:"flex", alignItems:"center", gap:10, width:"100%", padding:"10px 12px", border:"none", background:isActive?"rgba(181,112,63,0.1)":"transparent", cursor:"pointer", borderRadius:9, fontFamily:"'Jost',sans-serif", fontSize:14, color:"#2E2A24", textAlign:"left" }}
                onMouseEnter={e=>{ if(!isActive) e.currentTarget.style.background="rgba(181,112,63,0.05)"; }}
                onMouseLeave={e=>{ if(!isActive) e.currentTarget.style.background="transparent"; }}>
                <Icon size={17} color="#B5703F" />
                <span style={{ flex:1 }}>{meta.label}</span>
                {isActive && <span style={{ fontSize:11, color:"#B5703F", fontWeight:600 }}>Current</span>}
              </button>
            );
          })}
        </div>
      )}
      <button onClick={() => setOpen(o=>!o)}
        style={{ display:"flex", alignItems:"center", gap:9, padding:"10px 18px", background:"#2E2A24", color:"white", border:"none", borderRadius:30, cursor:"pointer", fontFamily:"'Jost',sans-serif", fontSize:13, fontWeight:500, boxShadow:"0 6px 22px rgba(46,42,36,0.3)" }}>
        <ActiveIcon size={16} color="#E8C7A8" />
        <span style={{ opacity:0.7 }}>Viewing as</span>
        <span style={{ fontWeight:700 }}>{active.label}</span>
        <ChevronDown size={15} style={{ transform: open?"rotate(180deg)":"none", transition:"transform 0.15s" }} />
      </button>
    </div>
  );
}
